<script lang="ts">
    import { createEventDispatcher } from "svelte"
    import { getDBEntries, postDBEntry } from "../../api"
    import { isMobile, login, newNotification } from "../store"
    import CardWrapper from "./CardWrapper.svelte"
    import CollapsibleWrapper from "./CollapsibleWrapper.svelte"
    import { onChange, validateField, validateInput } from "./formComponents/helper"
    import Input from "./formComponents/Input.svelte"
    import ToggleButton from "./ToggleButton.svelte"
    import Cta from "./CTA.svelte"
    import CompanySelect from "./formComponents/CompanySelect.svelte"
    import Select from "../taskSteps/inputfields/Select.svelte"
    const dispatch = createEventDispatcher()
    let selected = 0

    let resetForm = false
    function initOrderDetails(): {
        order: Order
        task: BaseTask
    } {
        resetForm = !resetForm
        return {
            order: {
                generalDetails: {
                    number: undefined,
                    includesTowingTask: false,
                    status: "open",
                    caller: {
                        name: "",
                        companyName: "",
                        telephone: "",
                    },
                },
            },
            task: {
                orderId: null,
                completedSteps: [],
                taskType: "oilSpillRemoval",
                status: "inProgress",
                meta: {
                    createdBy: {
                        id: $login?.tokenData?.id,
                        name: `${$login?.user?.firstName} ${$login?.user?.lastName}`,
                    },
                    editedBy: [],
                    contactPerson: {
                        id: "",
                        name: "",
                    },
                    executingCompany: "Wohner GmbH",
                },
                generalDetails: {
                    shortDescription: "",
                    description: "",
                },
            },
        }
    }
    function setCurrentOrderNumber() {
        let filter = {}
        if (orderDetails?.task?.taskType == "towing") {
            filter = {
                "generalDetails.includesTowingTask": true,
            }
            orderDetails.order.generalDetails.includesTowingTask = true
        } else {
            orderDetails.order.generalDetails.includesTowingTask = false
        }

        getDBEntries("order", filter, "-generalDetails.number", 1).then((res) => {
            orderDetails.order.generalDetails.number = res.length ? res[0].generalDetails.number + 1 : 1
        })
    }

    async function createOrder() {
        const validations = [
            { id: "callerName", value: orderDetails?.order.generalDetails.caller.name, validator: validateInput },
            {
                id: "callerTelephone",
                value: orderDetails?.order.generalDetails.caller.telephone,
                validator: validateInput,
            },
            { id: "executingCompany", value: orderDetails?.task.meta.executingCompany, validator: validateInput },
            { id: "contactPerson", value: orderDetails?.task.meta.contactPerson, validator: validateInput },
            {
                id: "shortDescription",
                value: orderDetails?.task.generalDetails.shortDescription,
                validator: validateInput,
            },
            { id: "description", value: orderDetails?.task.generalDetails.description, validator: validateInput },
        ]

        let isValid = true

        for (const { id, value, validator } of validations) {
            // @ts-ignore
            if (!validateField(id, value, validator)) isValid = false
        }
        if (!orderDetails?.order.generalDetails.caller.companyName) {
            newNotification({
                html: "Bitte geben Sie eine Firma an.",
                class: "error",
            })
            return
        }
        if (isValid) {
            const orderRes = await postDBEntry("order", {
                ...orderDetails?.order,
            })
            const order = orderRes.data
            if (!order.id) return
            orderDetails.task.orderId = order.id
            //@ts-ignore
            await postDBEntry("task", {
                ...orderDetails?.task,
                meta: {
                    contactPerson: orderDetails?.task.meta.contactPerson,
                    executingCompany: orderDetails?.task.meta.executingCompany,
                    assignedUsers: orderDetails?.task.meta.assignedUsers,
                    createdBy: {
                        id: $login.user.id,
                        name: `${$login.user.firstName} ${$login.user.lastName}`,
                    },
                    editedBy: [],
                },
            }).then(() => {
                newNotification({
                    html: "Auftrag und Einsatz angelegt.",
                    class: "success",
                })
                orderDetails = initOrderDetails()
                dispatch("updateOrderList")
            })
        }
    }
    let orderDetails: {
        order: Order
        task: BaseTask
    }
    orderDetails = initOrderDetails()
    setCurrentOrderNumber()
    $: if ($login && orderDetails?.task?.meta?.createdBy?.id !== $login.user.id)
        orderDetails.task.meta.createdBy = {
            id: $login.user.id,
            name: `${$login.user.firstName} ${$login.user.lastName}`,
        }

    $: if (orderDetails && orderDetails.task.taskType !== (selected == 0 ? "oilSpillRemoval" : "towing")) {
        orderDetails.task.taskType = selected == 0 ? "oilSpillRemoval" : "towing"
        setCurrentOrderNumber()
    }
</script>

<form on:submit|preventDefault|stopPropagation="{createOrder}">
    <div class="cols">
        <CardWrapper
            icon="solar_call-chat-outline.svg"
            title="Anrufer"
        >
            <div class="inner-card-wrapper">
                <Input
                    placeholder="Name"
                    id="callerName"
                    onChange="{onChange}"
                    bind:value="{orderDetails.order.generalDetails.caller.name}"
                />
                {#key resetForm}
                    <CompanySelect
                        bind:value="{orderDetails.order.generalDetails.caller.companyName}"
                        onBlur="{() => {}}"
                    />
                {/key}
                <Input
                    placeholder="Telefon"
                    id="callerTelephone"
                    onChange="{onChange}"
                    bind:value="{orderDetails.order.generalDetails.caller.telephone}"
                />
            </div>
        </CardWrapper>
        <CardWrapper
            icon="solar_clipboard-text-outline.svg"
            title="Auftrag & Einsatz anlegen"
        >
            <CollapsibleWrapper
                icon="solar_clipboard-text-outline.svg"
                title="Auftrag"
            >
                <div class="inner-card-wrapper">
                    <Input
                        id="number"
                        type="number"
                        placeholder="Auftragsnummer (Automatisch Vergeben)"
                        disabled="{true}"
                        onChange="{onChange}"
                        value="{orderDetails?.order.generalDetails.number}"
                    />
                </div>
            </CollapsibleWrapper>
            <CollapsibleWrapper
                icon="solar_checklist-outline.svg"
                title="Einsatz"
            >
                <div class="inner-card-wrapper">
                    <Input
                        placeholder="Angelegt von (Automatisch Vergeben)"
                        id="createdBy"
                        onChange="{onChange}"
                        value="{orderDetails.task.meta.createdBy.name}"
                        disabled="{true}"
                    />

                    <div style="height: 60px;">
                        <Select
                            field="{{
                                name: 'id',
                                label: 'Kontaktperson',
                                widget: 'select',
                                pathInDb: 'id',
                                options: {
                                    endpoint: 'user',
                                    params: {
                                        sort: 'username',
                                    },
                                    mapping: {
                                        id: 'id',
                                        name: 'username',
                                    },
                                },
                            }}"
                            bind:value="{orderDetails.task.meta.contactPerson.id}"
                        />
                    </div>
                    <div style="height: 60px;">
                        {#key selected}
                            <Select
                                field="{{
                                    name: 'id',
                                    label: 'Zugewiesene Personen',
                                    widget: 'select[]',
                                    pathInDb: 'id',
                                    options: {
                                        endpoint: 'user',
                                        params: {
                                            sort: 'username',
                                            filter:
                                                selected == 1
                                                    ? {
                                                          $or: [
                                                              {
                                                                  roles: 'admin',
                                                              },
                                                              {
                                                                  additionalPermissions: 'editTowingOrders',
                                                              },
                                                          ],
                                                      }
                                                    : {
                                                          $or: [
                                                              {
                                                                  roles: 'admin',
                                                              },
                                                              {
                                                                  additionalPermissions: 'editOilSpillOrders',
                                                              },
                                                          ],
                                                      },
                                        },
                                        mapping: {
                                            id: 'id',
                                            name: 'username',
                                        },
                                    },
                                }}"
                                bind:value="{orderDetails.task.meta.assignedUsers}"
                            />
                        {/key}
                    </div>
                    <Input
                        placeholder="Kurzbeschreibung"
                        id="shortDescription"
                        onChange="{onChange}"
                        bind:value="{orderDetails.task.generalDetails.shortDescription}"
                    />
                    <Input
                        placeholder="Beschreibung"
                        id="description"
                        type="textarea"
                        onChange="{onChange}"
                        smallTextarea="{true}"
                        bind:value="{orderDetails.task.generalDetails.description}"
                    />
                    {#if selected == 1}
                        <div style="height: 60px;">
                            <Select
                                field="{{
                                    name: 'damageType',
                                    label: 'Schadensart',
                                    widget: 'select',
                                    pathInDb: 'generalDetails.damageType',
                                    options: [
                                        {
                                            value: 'crash',
                                            label: 'Unfall',
                                        },
                                        {
                                            value: 'breakdown',
                                            label: 'Panne',
                                        },
                                    ],
                                }}"
                                bind:value="{orderDetails.task.generalDetails.damageType}"
                            />
                        </div>
                    {/if}

                    <ToggleButton
                        icon1="{selected == 0 ? 'solar_waterdrops-outline-white.svg' : 'solar_waterdrops-outline.svg'}"
                        icon2="{selected == 1 ? 'hugeicons_tow-truck-white.svg' : 'hugeicons_tow-truck.svg'}"
                        title1="{'ÖLWEHREINSATZ'}"
                        title2="{'ABSCHLEPPEINSATZ'}"
                        bind:selected="{selected}"
                    />
                </div>
            </CollapsibleWrapper>
        </CardWrapper>
    </div>
    <div
        class="action-buttons"
        style="{$isMobile ? 'justify-content: flex-start;' : ''}"
    >
        <div class="wrapper">
            <Cta
                type="secondaryButton"
                icon="solar_refresh-bold"
                content="{$isMobile ? '' : 'Zurücksetzen'}"
                on:click="{(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                    orderDetails = initOrderDetails()
                }}"
            />
            <Cta
                type="primaryButton"
                icon="solar_add-circle-outline"
                content="Auftrag & Einsatz anlegen"
                on:click
            />
        </div>
    </div>
</form>

<style lang="less">
    @import "../../../assets/variables.less";

    form {
        display: flex;
        flex-direction: column;
        gap: 1.2rem;
        .cols {
            display: flex;
            gap: 2.4rem;
            width: 100%;
            @media @mobile {
                flex-direction: column;
            }
            & > * {
                display: flex;
                flex-direction: column;
                gap: 1.2rem;
            }
            .inner-card-wrapper {
                display: flex;
                flex-direction: column;
                gap: 0.7rem;
                padding: 1.2rem;
            }
        }
    }

    .inner-card-wrapper {
        display: flex;
        flex-direction: column;
        gap: 1.2rem;
        width: 100%;
    }
    .action-buttons {
        display: flex;
        justify-content: flex-end;
        .wrapper {
            display: flex;
            gap: 2px;
            border-radius: 12px;
            border: 1px solid var(--grey-200);
            border-right: 0px solid black;
            background: var(--white-100);
        }
    }
</style>
